__turbopack_context__.v({
  "PDFZoom": "PDFZoom-module__FXj91a__PDFZoom",
  "PDFZoom__fixed": "PDFZoom-module__FXj91a__PDFZoom__fixed",
  "PDFZoom__middle": "PDFZoom-module__FXj91a__PDFZoom__middle",
  "PDFZoom__transparent": "PDFZoom-module__FXj91a__PDFZoom__transparent",
});
